module.exports = __webpack_public_path__ + "static/media/linkedin-disabled.7cd5e770.svg";